import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import { analyticsAPI } from '../../api/config';
import {
  fetchAnalyticsDashboardSuccess,
  fetchAnalyticsDashboardFailure,
  fetchAnalyticsVendorProductsSuccess,
  fetchAnalyticsVendorProductsFailure,
} from '../actions/analyticsActions';

function* fetchAnalyticsDashboardSaga(action) {
  try {
    const response = yield call(analyticsAPI.getDashboard, action.payload);
    yield put(fetchAnalyticsDashboardSuccess(response.data.data));
  } catch (error) {
    yield put(fetchAnalyticsDashboardFailure(error.message || 'Failed to fetch analytics'));
  }
}

function* fetchAnalyticsVendorProductsSaga(action) {
  try {
    const response = yield call(analyticsAPI.getVendorProducts, action.payload);
    yield put(fetchAnalyticsVendorProductsSuccess(response.data.data));
  } catch (error) {
    yield put(fetchAnalyticsVendorProductsFailure(error.message || 'Failed to fetch vendor products'));
  }
}

export default function* analyticsSaga() {
  yield takeLatest(types.FETCH_ANALYTICS_DASHBOARD_REQUEST, fetchAnalyticsDashboardSaga);
  yield takeLatest(types.FETCH_ANALYTICS_VENDOR_PRODUCTS_REQUEST, fetchAnalyticsVendorProductsSaga);
}
